import React from 'react';

import loc from 'sources/locale/loc';
import withContext from 'decorators/withContext';
import AuthContext from 'contexts/AuthContext';
import Button from './Button';

function LogButton(props) {
  const { onLogout, currentUser } = props;

  if (!currentUser) {
    return <Button label={loc('sign-in')} href="/login" variant="filled" />;
  }

  return <Button label={loc('logout')} onClick={onLogout} variant="filled" />;
}

export default withContext(AuthContext.Consumer)(LogButton);



// WEBPACK FOOTER //
// ./src/components/controls/LogButton.jsx